
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAuthQuery } from "../base/baseApi";
import { ApiResponse } from "../base/apiResponse";
import { SpecialityModeResponse } from "../../models/dtos";

export const specialityModesApi = createApi({
  reducerPath: 'specialityModesApi',
  baseQuery: baseAuthQuery('SpecialityModes'),
  tagTypes: ['SpecialityMode'],
  endpoints: (builder) => ({
    getSpecialityModes: builder.query<ApiResponse<SpecialityModeResponse[]>, void>({
      query: () => "",
      providesTags: ['SpecialityMode'],
    }),
    getSpecialityModeById: builder.query<ApiResponse<SpecialityModeResponse>, number>({
      query: (id) => ({ url: `/${id}` }),
      providesTags: ['SpecialityMode'],
    }),
    updateSpecialityMode: builder.mutation<ApiResponse<SpecialityModeResponse>, Partial<SpecialityModeResponse>>({
      query: (body) => ({ url: "CreateOrUpdate", method: "POST", body }),
      invalidatesTags: ['SpecialityMode'],
    }),
    deleteSpecialityMode: builder.mutation<ApiResponse<boolean>, number>({
      query: (id) => ({ url: `Delete/${id}`, method: "GET" }),
      invalidatesTags: ['SpecialityMode'],
    }),
  }),
});
